import React from "react";
import styled from "styled-components";

import { InactiveNoticeCard } from "components/cards/InactiveNoticeCard";

const InactivePage = () => {
  return (
    <InactivePageWrapper>
      <InactiveNoticeCard />
    </InactivePageWrapper>
  );
};

InactivePage.displayName = "InactivePage";
export default InactivePage;

const InactivePageWrapper = styled.div`
  background: var(--pale-sky);
  overflow: hidden;
`;
